export const validEntitiesAutocompleteProfiles = ['hotels', 'packages', 'flights',  'ds', 'cars', 'cruises']
export type EntitiesAutocompleteProfile = typeof validEntitiesAutocompleteProfiles[number];
export type EntitiesAutocompleteSearchType = 'cities' | 'hotels' | 'airports';
export type EntitiesAutocompleteReturnType = 'GID' | 'OID' | 'CODE' | 'GID|CODE';

export interface Entity {
  /** CIT_XXXX */
  gid: string;
  /** IATA */
  code: string;
  display: string;
}
